import { createContext, type Dispatch, type SetStateAction } from 'react';

export type TBundleOptions = 'silver' | 'gold' | 'diamond' | 'bronze' | null;

export interface IPaymentCard {
  brand: string;
  display: string;
  id: number;
  type: string;
  updated_at: string;
  token: string;
  partner_type: string;
  disclaimer: string;
  label: null;
  cardId?: string;
  customer_id?: string;
}

export interface ICheckoutData {
  profile: {
    id: string;
    balance?: string;
    email: string;
    name: string;
    phone: string;
    formatted_address?: string;
    formatted_document?: string;
  };
  currentBundleName?: string;
  bundlesData: {
    id: number;
    nameId: TBundleOptions;
    title: string;
    totalCoins: string;
    totalPrice: string;
    installmentValue: string;
    installments: [
      {
        value: 1;
        label: string;
      },
      {
        value: 2;
        label: string;
      },
      {
        value: 3;
        label: string;
      },
    ];
    installmentsDetails: {
      installmentCount: number;
      installmentValue: string;
    };
    installmentsLabel: string;
    purchaseLink: string;
    generateTokenInfos?: {
      createPaymentTokenIUGU: string;
      encryptionKey: string;
    };
  }[];
  authToken: string;
  coupon?: string;
  showRecurrencyModal: boolean;
  paymentCards?: IPaymentCard[];
}

interface ICheckoutContext {
  checkoutData: ICheckoutData;
  updateCheckoutData: Dispatch<SetStateAction<ICheckoutData>>;
}

export const initialValue: ICheckoutData = {
  authToken: '',
  bundlesData: [],
  showRecurrencyModal: false,
  profile: {
    name: '',
    email: '',
    id: '',
    phone: '',
  },
};

export const CheckoutContext = createContext<ICheckoutContext | null>(null);
